import { Buffer } from 'buffer';
void 0 === globalThis.Buffer && (globalThis.Buffer = Buffer);
